<template>
  <div>
    <section>
      <FullScreenImage
        :backgroundImage="require('../assets/background2.webp')"
        :isParalax="true"
        :paralaxHeight="paralaxHeight"
        :absolute="false"
        :isFullScreen="false"
      />
      <FloatingAvatar
        :avatar-size="250"
        :image-src="require('../assets/profilePic.webp')"
      />
    </section>
    <section style="min-height: 500px">
      <v-container text-xs-center pt-5 mt-5>
        <v-layout
          column
          align-center
          justify-center
          fill-height
          ref="description-section"
        >
          <v-spacer class="my-8"></v-spacer>
          <v-spacer class="my-8"></v-spacer>
          <v-flex display-1 mt-4 align-self-center>
            <h1>{{ personalDescription.title }}</h1>
          </v-flex>
          <transition name="fade">
            <v-flex v-show="canShowContent.description" xs4 my-5>
              <v-layout align-center justify-center fill-height>
                <v-flex xs12 md8>{{ personalDescription.text }}</v-flex>
              </v-layout>
            </v-flex>
          </transition>
        </v-layout>
        <transition name="fade">
          <v-layout
            v-show="canShowContent.description"
            row
            align-center
            justify-center
            fill-height
          >
            <v-flex xs12 md8 my-4 ref="carousel-container">
              <v-carousel
                cycle
                :height="carouselHeight"
                hide-delimiter-background
                show-arrows-on-hover
                class="c-carousel"
              >
              <v-carousel-item
                  v-for="(thumbnail, index) in PROJECTS_THUMBNAILS_LIST"
                  :key="index"
                  :src="thumbnail"
                  reverse-transition="fade-transition"
                  transition="fade-transition"
                  class="c-carousel__image"
                ></v-carousel-item>
              </v-carousel>
            </v-flex>
          </v-layout>
        </transition>
      </v-container>
    </section>
    <FullScreenImage
      :backgroundImage="require('../assets/background1.webp')"
      size="cover"
      :isParalax="true"
      :paralaxHeight="paralaxHeight"
      :absolute="false"
    />
    <section>
      <v-container text-xs-center>
        <v-layout
          column
          align-center
          justify-center
          fill-height
          ref="technology-section"
        >
          <v-spacer></v-spacer>
          <v-flex py-5>
            <v-layout align-center justify-center fill-height>
              <v-flex display-1 mt-4>
                <h1>{{ skillsDescription.title }}</h1>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex py-5>
            <transition name="fade">
              <v-layout fill-height wrap justify-center v-show="canShowContent.technologies">
                <template v-for="(mainTechnology, index) in mainTechnologies">
                  <v-flex shrink :key="index">
                    <v-avatar tile size="90" class="mx-4 my-2">
                      <img :src="getImageSrc(mainTechnology)" :alt="mainTechnology" />
                    </v-avatar>
                  </v-flex>
                </template>
              </v-layout>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
          <transition name="fade">
            <v-flex py-5 xs4 v-show="canShowContent.technologies">
              <v-layout align-center justify-center fill-height>
                <v-flex xs12 md8>{{ skillsDescription.text }}</v-flex>
              </v-layout>
            </v-flex>
          </transition>
        </v-layout>
      </v-container>
    </section>
    <section>
      <v-container text-xs-center>
        <v-layout column align-center justify-center ref="contact-section">
          <v-spacer></v-spacer>
          <v-flex py-5>
            <v-layout align-center justify-center fill-height>
              <v-flex display-1 mt-4>
                <h1>Get in touch</h1>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex py-5>
            <transition name="fade">
              <v-layout
                align-center
                justify-center
                fill-height
                v-show="canShowContent.contact"
              >
                <v-flex pa-4>
                  <v-layout column align-center justify-center>
                    <v-flex>
                      <a :href="contactLinks.linkedin" target="_blank">
                        <v-img
                          :aspect-ratio="1"
                          width="80"
                          height="80"
                          :src="require('../assets/linkedin.webp')"
                        ></v-img>
                      </a>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex pa-4>
                  <v-layout column align-center justify-center>
                    <v-flex>
                      <a :href="'mailto:' + contactLinks.gmail">
                        <v-img
                          :aspect-ratio="1"
                          width="80"
                          height="80"
                          :src="require('../assets/gmail.webp')"
                        ></v-img>
                      </a>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex pa-4>
                  <v-layout column align-center justify-center>
                    <v-flex>
                      <a :href="contactLinks.github" target="_blank">
                        <v-img
                          :aspect-ratio="1"
                          width="80"
                          height="80"
                          :src="require('../assets/github.webp')"
                        ></v-img>
                      </a>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-container>
    </section>
    <section>
      <v-container>
        <v-layout column align-center justify-center>
          <v-flex>&copy; Edgar Dias - 2019</v-flex>
        </v-layout>
      </v-container>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FloatingAvatar from "../components/Avatar/FloatingAvatar";
import FullScreenImage from "../components/FullScreenImage";

export default {
  name: "Home",
  data() {
    return {
      scrollOptions: {
        duration: 1000,
        offset: 0,
        easing: "easeInOutCubic",
      },
      contentPositions: {
        description: 0,
        technologies: 0,
        contact: 0,
      },
      canShowContent: {
        description: false,
        technologies: false,
        contact: false,
      },
      carouselHeight: 500,
    };
  },
  computed: {
    ...mapGetters("personalDetail/", {
      personalDescription: "PERSONAL_DESCRIPTION",
      skillsDescription: "SKILLS_DESCRIPTION",
      contactLinks: "CONTACT_LINKS",
      yearsOfExperience: "YEARS_OF_EXPERIENCE",
      mainTechnologies: "MAIN_TECHNOLOGIES",
    }),
    ...mapGetters("galleryProjects/", ["PROJECTS_THUMBNAILS_LIST"]),
    paralaxHeight() {
      let screenWidth = window.outerWidth;
      let screenHeight = window.outerHeight;
      let breakpoints = {
        mobile: 415,
        tablet: 768,
        desktop: 1024,
      };

      if (screenWidth < breakpoints.mobile) {
        return (screenHeight / 2.5).toString();
      }
      if (
        (screenWidth >= breakpoints.mobile &&
          screenWidth < breakpoints.tablet) ||
        (screenWidth >= breakpoints.tablet && screenWidth < breakpoints.desktop)
      ) {
        return (screenHeight / 3).toString();
      }

      return (500).toString();
    },
  },
  methods: {
    ...mapActions("personalDetail/", ["SET_PERSONAL_DETAILS"]),
    ...mapActions("galleryProjects/", ["GET_PROJECTS_THUMBNAILS"]),
    getImageSrc(imageName) {
      return require(`../assets/${imageName}.webp`);
    },
    handleScroll() {
      let windowPosition = window.scrollY + window.innerHeight;

      this.contentPositions.description =
        this.$refs["description-section"].offsetTop +
        this.$refs["description-section"].offsetHeight / 2;

      this.contentPositions.technologies =
        this.$refs["technology-section"].offsetTop +
        this.$refs["technology-section"].offsetHeight / 2;

      this.contentPositions.contact =
        this.$refs["contact-section"].offsetTop +
        this.$refs["contact-section"].offsetHeight / 2;

      switch (true) {
        case this.contentPositions.contact < windowPosition:
          this.canShowContent.contact = true;
          break;
        case this.contentPositions.technologies < windowPosition:
          this.canShowContent.technologies = true;
          break;
        case this.contentPositions.description < windowPosition:
          this.canShowContent.description = true;
          this.setCarouselheight();
          break;
      }
    },
    setCarouselheight() {
      this.carouselHeight =
        this.$refs["carousel-container"].clientWidth / 1.778;
    },
    handleCarouselHeight() {
      let timeOut;
      let _this = this;
      clearTimeout(timeOut);
      timeOut = setTimeout(function () {
        _this.setCarouselheight();
      }, 300);
    },
  },
  components: {
    FullScreenImage,
    FloatingAvatar,
  },
  created() {
    this.SET_PERSONAL_DETAILS();
    this.GET_PROJECTS_THUMBNAILS();
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleCarouselHeight);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleCarouselHeight);
  },
};
</script>
